module.exports = __webpack_public_path__ + "images/emoji/star2.37f7f284f60322c9f416.png";